import { useState } from "react";
import { toast } from "sonner";
import { HeartHandshake, Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AMOUNTS = [3, 5, 10, 25];

export const TipDialog = ({ open, onOpenChange, artist }) => {
  const { user } = useAuth();
  const [amount, setAmount] = useState(5);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!user) return toast.error("Sign in to support artists");
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { kind: "tip", artist_id: artist.user_id, tip_amount: amount, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#12121A] border-white/10" data-testid="tip-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2"><HeartHandshake className="text-[var(--hub)]" /> Support {artist.name}</DialogTitle>
          <DialogDescription>One-time tip, processed securely by Stripe. Prices include applicable VAT.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-4 gap-2">
          {AMOUNTS.map((a) => (
            <button key={a} data-testid={`tip-amount-${a}`} onClick={() => setAmount(a)}
              className={`py-4 rounded-xl font-display text-2xl font-bold border transition-colors ${amount === a ? "bg-[var(--hub)] border-transparent text-white" : "border-white/10 hover:border-white/30"}`}>${a}</button>
          ))}
        </div>
        {!artist.payouts_enabled && (
          <p className="flex gap-2 text-xs text-zinc-400"><Lock size={14} className="shrink-0" /> This artist hasn't finished payout verification yet. Your tip is held safely and released once their KYC completes.</p>
        )}
        <Button data-testid="tip-checkout-button" disabled={busy} onClick={go} className="w-full rounded-full h-12 bg-white text-black hover:bg-zinc-200">Continue to secure checkout · ${amount}</Button>
      </DialogContent>
    </Dialog>
  );
};
